.tracks { display: flex; flex-direction: column; }
.trackTools { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding-bottom: 6px; }
.trackHint { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--text-secondary); }
.trackHint[data-part='phone-hint'] { display: none; }
.track { display: flex; align-items: center; gap: 16px; padding: 6px 0; border-bottom: var(--border-hair); }
.trackLabel { width: 150px; flex: none; display: flex; flex-direction: column; gap: 2px; }
.trackName { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.3px; }
.trackName[data-kind='hr'] { color: var(--hot); }
.trackAvg { font-family: var(--font-cond); font-size: 26px; font-weight: 900; }
.trackNote { font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.8px; color: var(--text-secondary); }
.plot { flex: 1; min-width: 0; }

.content { display: grid; grid-template-columns: minmax(0, 1fr) 500px; grid-template-areas: "back back" "head actions" "map summary" "curve zones" "streams streams"; gap: 28px; align-items: start; padding: 28px var(--page-x) 48px; }
.state { grid-column: 1 / -1; }
.back { grid-area: back; justify-self: start; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.3px; }
.header { grid-area: head; display: flex; flex-direction: column; gap: 8px; align-self: end; min-width: 0; }
.actions { grid-area: actions; display: flex; align-items: center; justify-content: flex-end; gap: 16px; align-self: end; }
.stravaLink { font-size: 10px; }
.banner { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
/* Two classes: .alert-amber sets margin: 0, and global.css loads after this module. */
.header > .banner { margin-top: 8px; }
.banner[data-tone='hot'] { background: var(--hot-8); border-color: var(--hot); }
.mapArea { grid-area: map; min-width: 0; }
.route { display: flex; flex-direction: column; gap: 8px; }
.routeLabel { display: none; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); }
.mapBox { height: 420px; display: flex; align-items: center; justify-content: center; background: var(--paper-2); border: var(--border-panel); }
.noMap { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); }
.summary { grid-area: summary; display: flex; flex-direction: column; gap: 16px; min-width: 0; }
.loadCard { display: flex; flex-direction: column; gap: 10px; padding: 24px; background: var(--ink); box-shadow: 6px 6px 0 var(--hot); }
.loadLabel { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.4px; color: var(--pink); }
.loadValue { font-family: var(--font-cond); font-size: 96px; font-weight: 900; letter-spacing: -4px; line-height: 0.85; color: var(--paper); }
.formula { font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.6px; color: var(--paper-60); white-space: pre-wrap; }
.tiles { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin: 0; }
.tile { display: flex; flex-direction: column; gap: 4px; min-width: 0; padding: 14px 16px; border: var(--border-hair); }
.tileLabel { font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--text-secondary); }
.tileValue { margin: 0; font-family: var(--font-cond); font-size: 38px; font-weight: 900; letter-spacing: -1.2px; line-height: 1; }
.tileNote { margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.8px; color: var(--text-secondary); }
.streams { grid-area: streams; display: flex; flex-direction: column; gap: 6px; min-width: 0; padding: 24px; border: var(--border-panel); }
.streamsTitle { margin: 0; padding-bottom: 8px; font-family: var(--font-cond); font-size: 34px; font-weight: 800; letter-spacing: -1.2px; }
.zonesArea { grid-area: zones; min-width: 0; }
.curveArea { grid-area: curve; min-width: 0; }

.loadTop { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.tileValue[data-muted='true'] { color: var(--text-secondary); }
.paceLegend { display: flex; flex-direction: column; gap: 4px; margin: 0; padding: 6px 0 0; list-style: none; font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.8px; color: var(--text-secondary); }
.paceLegend li { display: flex; align-items: center; gap: 6px; }
.paceSwatch { display: inline-block; width: 14px; height: 1.5px; background: var(--ink); }
.paceSwatch[data-series='gap'] { height: 2.5px; background: var(--sport-run); }
.paceSwatch[data-series='threshold'] { height: 1px; background: var(--hot); }
.plot { position: relative; }
.paceCorner { position: absolute; top: 0; right: 0; z-index: 1; font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.8px; color: var(--text-secondary); }
/* An HR-only session without GPS has no map: the Load card (560) and its tiles share the hero row. */
.content:has(> .summary[data-wide='true']) { grid-template-areas: "back back" "head actions" "summary summary" "curve zones" "streams streams"; }
.summary[data-wide='true'] { flex-direction: row; align-items: flex-start; gap: 28px; }
.summary[data-wide='true'] > .loadCard { flex: none; width: 560px; }
.summary[data-wide='true'] > .tiles { flex: 1; grid-template-columns: repeat(2, 1fr); }

@media (max-width: 1023px) {
  .content { grid-template-columns: minmax(0, 1fr) auto; grid-template-areas: "back back" "head actions" "map map" "summary summary" "curve curve" "zones zones" "streams streams"; }
  .content:has(> .summary[data-wide='true']) { grid-template-areas: "back back" "head actions" "summary summary" "curve curve" "zones zones" "streams streams"; }
}

@media (max-width: 639px) {
  .content { grid-template-columns: minmax(0, 1fr); grid-template-areas: "back" "head" "summary" "streams" "map" "curve" "zones" "actions"; gap: 20px; padding: 8px var(--page-x) 32px; }
  .back { display: inline-flex; align-items: center; min-height: 44px; font-size: 11px; }
  .header { align-self: start; }
  .actions { gap: 12px; justify-content: stretch; }
  .actions > * { flex: 1; min-width: 0; }
  .actions :global(.btn), .stravaLink { font-size: 11px; letter-spacing: 1px; }
  .actions svg { width: 14px; height: 14px; }
  .stravaLink { display: inline-flex; align-items: center; justify-content: center; min-height: 48px; border: var(--border-control); }
  .routeLabel { display: block; }
  .mapBox { height: 186px; }
  .loadCard { padding: 20px; box-shadow: 4px 4px 0 var(--hot); }
  .loadValue { font-size: 84px; }
  .formula { line-height: 1.6; }
  .formula [data-part='sep'] { display: none; }
  .tiles { gap: 12px; grid-template-columns: repeat(2, 1fr); }
  .tile[data-tile='duration'] { order: 1; }
  .tile[data-tile='distance'] { order: 2; }
  .tile[data-tile='wpower'] { order: 3; }
  .tile[data-tile='intensity'] { order: 4; }
  .tile[data-tile='hr'] { order: 5; }
  .tile[data-tile='elevation'] { order: 6; }
  .streams { gap: 10px; padding: 14px; box-shadow: none; }
  .streamsTitle { padding-bottom: 4px; font-size: 26px; letter-spacing: -1px; }

  .trackTools { flex-direction: column-reverse; align-items: stretch; }
  .trackHint { font-size: 9px; line-height: 1.5; }
  .trackHint[data-part='desktop-hint'] { display: none; }
  .trackHint[data-part='phone-hint'] { display: block; }
  .track { flex-direction: column; align-items: stretch; gap: 6px; padding: 6px 0 8px; }
  .trackLabel { width: auto; flex-direction: row; align-items: flex-end; gap: 8px; }
  .trackAvg { font-size: 20px; line-height: 1; }
  .content:has(> .summary[data-wide='true']) { grid-template-areas: "back" "head" "summary" "streams" "map" "curve" "zones" "actions"; }
  .summary[data-wide='true'] { flex-direction: column; align-items: stretch; gap: 16px; }
  .summary[data-wide='true'] > .loadCard { width: auto; }
  .formula [data-part='threshold'] { display: block; }
  .tiles[data-layout='run'] .tile[data-tile='distance'] { order: 1; }
  .tiles[data-layout='run'] .tile[data-tile='moving'] { order: 2; }
  .tiles[data-layout='run'] .tile[data-tile='pace'] { order: 3; }
  .tiles[data-layout='run'] .tile[data-tile='gap'] { order: 4; }
  .tiles[data-layout='run'] .tile[data-tile='hr'] { order: 5; }
  .tiles[data-layout='run'] .tile[data-tile='intensity'] { order: 6; }
  .tiles[data-layout='hr'] .tile[data-tile='duration'] { order: 1; }
  .tiles[data-layout='hr'] .tile[data-tile='hr'] { order: 2; }
  .tiles[data-layout='hr'] .tile[data-tile='intensity'] { order: 3; }
  .tiles[data-layout='hr'] .tile[data-tile='distance'] { order: 4; }
  .tiles[data-layout='hr'] .tile[data-tile='source'] { order: 5; }
  .paceLegend { flex-direction: row; gap: 12px; letter-spacing: 0.6px; }
  .paceSwatch { width: 12px; }
  .paceCorner { display: none; }
}
